import scrollIntoView from 'scroll-into-view-if-needed';

export const scrollToFeedbackMessage = (
  scrollElId: string,
  dataAttribute: string,
) => {
  requestAnimationFrame(() => {
    const scrollEl = document.querySelectorAll(
      `#feedback-details [${dataAttribute}="${scrollElId}"]`,
    )[0];

    if (!scrollEl) {
      return;
    }

    scrollIntoView(scrollEl, {
      behavior: 'smooth',
      block: 'center',
      inline: 'center',
      boundary: document.getElementById('feedback-details'),
    });
  });
};
